import React from 'react';
import { Provider, connect } from 'react-redux';
import store from '../store/store';
import { browserHistory, Router, Route, IndexRedirect } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { Modal, Button, Col, Row } from 'react-bootstrap';
import { Auth } from './auth/Auth.jsx';
import {PasswordChange} from './auth/PasswordChange.jsx';
import {PasswordReset} from './auth/PasswordReset.jsx';
import { requireAuth, requireAuthOnChange } from './auth/auth';
import { ThroughProvider } from 'react-through';
import UsersList from './managment/users/List.jsx';
import InterestRate from './managment/interestrate/Edit.jsx';
import UserEdit from './managment/users/Edit.jsx';
import Profile from './managment/users/Profile.jsx';
import Deals, { Purchase, Transport, Sale, Payments,
  CommonPayments, Unlinked } from './blogic/deals/Container.jsx';
import { PurchaseEditAndLink, SaleEditAndLink } from './blogic/deals/link/EditAndLink.jsx';
import TransportEdit from './blogic/deals/transport/Edit.jsx';
import PackingList from './dict/simple/packing/List.jsx';
import PackingEdit from './dict/simple/packing/Edit.jsx';
import DeliveryTermList from './dict/simple/deliveryterm/List.jsx';
import DeliveryTermEdit from './dict/simple/deliveryterm/Edit.jsx';
import OriginList from './dict/simple/origin/List.jsx';
import OriginEdit from './dict/simple/origin/Edit.jsx';
import SupplierList from './dict/simple/supplier/List.jsx';
import SupplierEdit from './dict/simple/supplier/Edit.jsx';
import BuyerList from './dict/simple/buyer/List.jsx';
import BuyerEdit from './dict/simple/buyer/Edit.jsx';
import PortList from './dict/simple/port/List.jsx';
import PortEdit from './dict/simple/port/Edit.jsx';
import ExpensesCategoryList from './dict/simple/expensecategory/List.jsx';
import ExpensesCategoryEdit from './dict/simple/expensecategory/Edit.jsx';
import ExpensesTypeList from './dict/complex/expensestype/List.jsx';
import ExpensesTypeEdit from './dict/complex/expensestype/Edit.jsx';
import LoadingTermList from './dict/simple/loadingterm/List.jsx';
import LoadingTermEdit from './dict/simple/loadingterm/Edit.jsx';
import OwnerList from './dict/simple/owner/List.jsx';
import OwnerEdit from './dict/simple/owner/Edit.jsx';
import VesselBrokerList from './dict/simple/vesselbroker/List.jsx';
import VesselBrokerEdit from './dict/simple/vesselbroker/Edit.jsx';
import ForwarderList from './dict/simple/forwarder/List.jsx';
import ForwarderEdit from './dict/simple/forwarder/Edit.jsx';
import ShippingLineList from './dict/simple/shippingline/List.jsx';
import ShippingLineEdit from './dict/simple/shippingline/Edit.jsx';
import BankList from './dict/simple/bank/List.jsx';
import BankEdit from './dict/simple/bank/Edit.jsx';
import ProducerList from './dict/simple/producer/List.jsx';
import ProducerEdit from './dict/simple/producer/Edit.jsx';
import ProductList from './dict/complex/product/List.jsx';
import DocumentTypeList from './dict/simple/documenttype/List.jsx';
import DocumentTypeEdit from './dict/simple/documenttype/Edit.jsx';
import RegionList from './dict/simple/region/List.jsx';
import PortGroupList from './dict/simple/portgroup/List.jsx';

import PaymentMethodList from './dict/simple/paymentmethod/List.jsx';
import PaymentMethodEdit from './dict/simple/paymentmethod/Edit.jsx';
import CommonCounterpartiesList from './dict/simple/commoncounterparties/List.jsx';
import CommonCounterpartiesEdit from './dict/simple/commoncounterparties/Edit.jsx';
import TradeCounterpartiesList from './dict/simple/tradecounterparties/List.jsx';
import TradeCounterpartiesEdit from './dict/simple/tradecounterparties/Edit.jsx';
import InsuranceCompanyList from './dict/simple/insurancecompany/List.jsx';
import InsuranceCompanyEdit from './dict/simple/insurancecompany/Edit.jsx';
import InspectionCompanyList from './dict/simple/inspectioncompany/List.jsx';
import InspectionCompanyEdit from './dict/simple/inspectioncompany/Edit.jsx';
import TopManagerList from './dict/simple/topmanager/List.jsx';
import TopmanagerEdit from './dict/simple/topmanager/Edit.jsx';
import { saveEntryPointKey } from '../store/allaround.store.js';
import CurrencyLine from './dict/currency/List.jsx';
import { hidePopup } from '../store/error.store';
// import createBrowserHistory from 'history/lib/createBrowserHistory';
// import { useBeforeUnload } from 'history';
import LoadingScreenComponent from './loadingscreen/LoadingScreen';
import './app.less';
import Perf from 'react-addons-perf';
// import { RestAPI } from '@/util/net.js';
import { MainComponentBox } from '@/util/util.jsx';
// import { addUsage } from '@/store/usermetrics.store.js';
import { initMyDeals } from './blogic/deals/store/search.store';
import { fetchUserNotifications } from '../store/notification.store';
import Alert from '../util/Alert.jsx';
import CurrencyDisplay from './currencies/CurrencyDisplay';

import GlobalSearchResults from './blogic/deals/search/GlobalSearchResults';
import { openWS } from '@/store/websocket/dispatcher';
import ShortTermNotifications from './notifications/ShortTermNotifications';
import Reindex from './managment/Reindex';
import Loadable from 'react-loadable';


const LoadingPlaceHolder = () => <MainComponentBox>Loading...</MainComponentBox>;

const Roles = Loadable({
  loader: () => import(/* webpackChunkName: "Roles" */'./managment/roles/Edit.jsx'),
  loading: LoadingPlaceHolder,
});

const SystemCurrencies = Loadable({
  loader: () => import(
    /* webpackChunkName: "SystemCurrencies" */'./managment/systemcurrencies/Edit.jsx'),
  loading: LoadingPlaceHolder,
});

const Prices = Loadable({
  loader: () => import(/* webpackChunkName: "Prices" */'./managment/prices/Edit.jsx'),
  loading: LoadingPlaceHolder,
});

const DealsCutoffDate = Loadable({
  loader: () => import(/* webpackChunkName: "DealsCutoffDate" */'./managment/cutoff/Edit.jsx'),
  loading: LoadingPlaceHolder,
});

const BugReportsList = Loadable({
  loader: () => import(/* webpackChunkName: "BugReportsList" */'./managment/bugreports/List.jsx'),
  loading: LoadingPlaceHolder,
});

const CounterpartyOutstanding = Loadable({
  loader: () => import(/* webpackChunkName: "CounterpartyOutstanding" */
    './blogic/deals/payments/CounterpartyOutstanding.jsx'),
  loading: LoadingPlaceHolder,
});

const CounterpartyOutstandingValues = Loadable({
  loader: () => import(/* webpackChunkName: "CounterpartyOutstanding" */
    './blogic/deals/payments/CounterpartyOutstandingValues.jsx'),
  loading: LoadingPlaceHolder,
});

const ProductTypeEdit = Loadable({
  loader: () => import(/* webpackChunkName: "ProductTypeEdit" */
    './dict/complex/product/Edit.jsx').then(m => m.ProductTypeEdit),
  loading: LoadingPlaceHolder,
});
const SubTypeEdit = Loadable({
  loader: () => import(/* webpackChunkName: "SubTypeEdit" */
    './dict/complex/product/Edit.jsx').then(m => m.SubTypeEdit),
  loading: LoadingPlaceHolder,
});
const RegionEdit = Loadable({
  loader: () => import(/* webpackChunkName: "RegionEdit" */'./dict/simple/region/Edit.jsx'),
  loading: LoadingPlaceHolder,
});
const PortGroupEdit = Loadable({
  loader: () => import(/* webpackChunkName: "PortGroupEdit" */'./dict/simple/portgroup/Edit.jsx'),
  loading: LoadingPlaceHolder,
});

const CalendarList = Loadable({
  loader: () => import(/* webpackChunkName: "CalendarList" */'./calendar/List.jsx'),
  loading: LoadingPlaceHolder,
});


const TodaysPayments = Loadable({
  loader: () => import(/* webpackChunkName: "TodaysPayments" */'./blogic/reports/TodaysPayments'),
  loading: LoadingPlaceHolder,
});

const SupplyDemand = Loadable({
  loader: () => import(/* webpackChunkName: "SupplyDemand" */'./blogic/reports/SupplyDemand'),
  loading: LoadingPlaceHolder,
});

const UnlinkedRegions = Loadable({
  loader: () => import(/* webpackChunkName: "UnlinkedRegions" */'./blogic/reports/UnlinkedRegions'),
  loading: LoadingPlaceHolder,
});
const PositionBook = Loadable({
  loader: () => import(/* webpackChunkName: "PositionBook" */ './blogic/reports/PositionBook'),
  loading: LoadingPlaceHolder,
});
const OpenPosition = Loadable({
  loader: () => import(/* webpackChunkName: "OpenPosition" */ './blogic/reports/OpenPosition'),
  loading: LoadingPlaceHolder,
});
const Profitability = Loadable({
  loader: () => import(/* webpackChunkName: "Profitability" */ './blogic/reports/Profitability'),
  loading: LoadingPlaceHolder,
});
const VolumeReport = Loadable({
  loader: () => import(/* webpackChunkName: "VolumeReport" */ './blogic/reports/VolumeReport'),
  loading: LoadingPlaceHolder,
});
const UnifiedDeals = Loadable({
  loader: () => import(/* webpackChunkName: "UnifiedDeals" */ './blogic/reports/UnifiedDeals'),
  loading: LoadingPlaceHolder,
});
const PaymentsReport = Loadable({
  loader: () => import(/* webpackChunkName: "PaymentsReport" */ './blogic/reports/PaymentsReport'),
  loading: LoadingPlaceHolder,
});
const MapComponent = Loadable({
  loader: () => import(/* webpackChunkName: "GoogleMaps" */ './blogic/reports/GoogleMaps.jsx'),
  loading: LoadingPlaceHolder,
});
const PerformanceReport = Loadable({
  loader: () => import(/* webpackChunkName: "PerformanceReport" */
    './blogic/reports/PerformanceReport.jsx'),
  loading: LoadingPlaceHolder,
});

const AnalyticsReport = Loadable({
  loader: () => import(/* webpackChunkName: "AnalyticsReport" */
    './blogic/reports/AnalyticsReport.jsx'),
  loading: LoadingPlaceHolder,
});

const UserPerformanceReport = Loadable({
  loader: () => import(/* webpackChunkName: "UserPerformanceReport" */
    './blogic/reports/UserPerformance.jsx'),
  loading: LoadingPlaceHolder,
});

const MultiNodalReport = Loadable({
  loader: () => import(/* webpackChunkName: "MultiNodalReport" */
    './blogic/reports/MultiNodalReport.jsx'),
  loading: LoadingPlaceHolder,
});
const EarningStatementsReport = Loadable({
  loader: () => import(/* webpackChunkName: "EarningStatementReport" */
    './blogic/reports/EarningStatements.jsx'),
  loading: LoadingPlaceHolder,
});


if (!(process.env && process.env.NODE_ENV == 'production')) {
  window.Perf = Perf;
}
/*
function postStats() {
  RestAPI.post('/usermetrics', store.getState().get('usage').toJS());
  return true;
}
const browserHistoryUnloadListener = useBeforeUnload(createBrowserHistory)();
browserHistoryUnloadListener.listenBeforeUnload(postStats);
*/

let prevHistoryValue = {};
let prevValueAsJson = {};
// Create an enhanced history that syncs navigation events with the store
const history = syncHistoryWithStore(browserHistory, store, {
  selectLocationState: (state) => {
    if (!(prevHistoryValue === state.get('routing'))) {
      prevHistoryValue = state.get('routing');

      // Save app entry point
      const entryPointKey = store.getState().getIn(['allaround', 'entryPointKey']);
      if (!entryPointKey && prevValueAsJson.locationBeforeTransitions
        && prevValueAsJson.locationBeforeTransitions.pathname
        && prevValueAsJson.locationBeforeTransitions.pathname !=
        state.getIn(['routing', 'locationBeforeTransitions', 'pathname'])) {
        const previousPathKey = prevValueAsJson.locationBeforeTransitions.key;
        if (previousPathKey) {
          saveEntryPointKey(store.dispatch, previousPathKey);
        }
      }

      // Save location change details to store
      if (prevHistoryValue && prevHistoryValue.getIn(['locationBeforeTransitions', 'pathname']) &&
        prevValueAsJson && prevValueAsJson.locationBeforeTransitions) {
        let from = prevValueAsJson.locationBeforeTransitions.pathname;
        let to = prevHistoryValue.getIn(['locationBeforeTransitions', 'pathname']);
        if (from != to) {
          const fromWithoutId = from.match('^(.*!?)(/[0-9]*)$');
          const toWithoutId = to.match('^(.*!?)(/[0-9]*)$');
          if (fromWithoutId) {
            from = `${fromWithoutId[1]}/id`;
          }
          if (toWithoutId) {
            to = `${toWithoutId[1]}/id`;
          }
          /*
          Выключил usermetrics
          setTimeout(() => addUsage(store.dispatch, from, to), 0);
          */
        }
      }

      prevValueAsJson = state.get('routing').toJS();
    }
    return prevValueAsJson;
  },
});

const mapStateToProps = state => ({
  loaded: state.getIn(['storage', 'loaded']),
});

const mapDispatchToProps = () => ({});


const LoadingScreen = connect(mapStateToProps, mapDispatchToProps)(props =>
  (!props.loaded ? <LoadingScreenComponent loading /> : props.children),
);

class AppClass extends React.Component {
  constructor(props) {
    super(props);
    document.title = this.getTitle(props);
    this.wsOpen = false;
    this.initWs = this.initWs.bind(this);
  }

  getChildContext() {
    return { location: this.props.location };
  }

  componentWillMount() {
    this.props.initMyDeals();
  }

  componentDidMount() {
    this.props.fetchUserNotifications();
    this.initWs();
  }

  componentWillReceiveProps(props) {
    document.title = this.getTitle(props);
    this.initWs(props);
  }
  shouldComponentUpdate(nextProps) {
    if (this.props && nextProps
      && this.props.isLoading == true && nextProps.isLoading == true
      && this.props.loginStatus && nextProps.loginStatus) {
      return false;
    }
    return true;
  }

  getTitle(props) {
    if (props.routes && Array.isArray(props.routes)) {
      return props.routes[props.routes.length - 1].title || 'Dreymoor';
    }
    return 'Dreymoor';
  }

  initWs(props = this.props) {
    if (props.loginStatus == 'LOGGED_IN' && !this.wsOpen) {
      openWS(store);
      this.wsOpen = true;
    }
  }

  render() {
    if (!this.props.loginStatus) {
      setTimeout(() => {
        browserHistory.replace(location);
      }, 0);
    }
    return (
      <ThroughProvider>
        <LoadingScreenComponent loading={this.props.isLoading}>
          <ShortTermNotifications />
          <Modal
            show={this.props.errors && this.props.errors.size > 0
            && this.props.errors.get('alert') != true
            && this.props.errors.get('exception') !== undefined
            && !this.props.errors.get('popupHidden')}
            onHide={() => this.props.hidePopup()}
          >
            <Modal.Body>
              {this.props.errors.entrySeq().map((err, idx) =>
                (err !== undefined && err[1] !== false && err[0] !== 'popupHidden' ?
                  // eslint-disable-next-line
                  <Row key={idx}><Col xs={12} >{err[0]}{err[1] ? ` : ${err[1]}` : ''}</Col></Row>
                  : ''))}
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={() => this.props.hidePopup()}>Close</Button>
            </Modal.Footer>
          </Modal>
          <Alert
            show={this.props.errors && this.props.errors.size > 0
            && this.props.errors.get('alert') == true
            && !this.props.errors.get('popupHidden')}
            message={this.props.errors.get('message')}
            hideAlert={this.props.hidePopup}
          />
          <div id="main-body">
            {this.props.children}
            <CurrencyDisplay />
          </div>
        </LoadingScreenComponent>
      </ThroughProvider>);
  }
}

AppClass.propTypes = {
  loginStatus: React.PropTypes.string,
  children: React.PropTypes.oneOfType([React.PropTypes.object, React.PropTypes.array]),
  isLoading: React.PropTypes.bool,
  hidePopup: React.PropTypes.func,
  errors: React.PropTypes.object,
  location: React.PropTypes.object,
  fetchUserNotifications: React.PropTypes.func,
  initMyDeals: React.PropTypes.func,
};

AppClass.childContextTypes = {
  location: React.PropTypes.object,
};

const App = connect(
  (state) => ({
    loginStatus: state.getIn(['session', 'state']),
    isLoading: state.getIn(['storeStatus', 'isLoading'], false),
    errors: state.get('error'),
  }),
  (dispatch) => ({
    hidePopup() {
      hidePopup(dispatch);
    },
    fetchUserNotifications() {
      fetchUserNotifications(dispatch);
    },
    initMyDeals() {
      initMyDeals(dispatch);
    },
  })
)(AppClass);

export default function () {
  return (<Provider store={store}>
    <LoadingScreen>
      <Router history={history}>
        <Route
          path="/" component={App} onEnter={requireAuth} onChange={requireAuthOnChange} title="Main"
        >
          <IndexRedirect to="/deals/unlinked" />
          <Route path="management/users" title="Users" component={UsersList} />
          <Route path="management/roles" title="Roles" component={Roles} />
          <Route
            path="management/systemcurrencies"
            title="System currencies"
            component={SystemCurrencies}
          />
          <Route path="management/pricesdb" title="External databases" component={Prices} />
          <Route path="management/cutoff" title="Deals cutoff date" component={DealsCutoffDate} />
          <Route path="management/interestrate" title="Interest rate" component={InterestRate} />
          <Route path="management/bugreports" title="Bug reports" component={BugReportsList} />
          <Route path="management/users/:userId" title="User edit" component={UserEdit} />
          <Route path="management/reindex" title="Reindex" component={Reindex} />
          <Route path="profile" title="Profile" component={Profile} />
          <Route path="calendar" title="Calendar" component={CalendarList} />
          <Route path="references">
            <IndexRedirect to="/references/packing" />
            <Route path="packing" title="Packing" component={PackingList} />
            <Route path="packing/:refId" title="Packing edit" component={PackingEdit} />
            <Route path="deliveryterm" title="Delivery term" component={DeliveryTermList} />
            <Route
              path="deliveryterm/:refId" title="Delivery term edit" component={DeliveryTermEdit}
            />
            <Route path="origin" title="Origins/Destinations" component={OriginList} />
            <Route path="origin/:refId" title="Origin edit" component={OriginEdit} />
            <Route path="supplier" title="Seller" component={SupplierList} />
            <Route path="supplier/:refId" title="Seller edit" component={SupplierEdit} />
            <Route path="buyer" title="Buyer" component={BuyerList} />
            <Route path="buyer/:refId" title="Buyer edit" component={BuyerEdit} />
            <Route path="port" title="Port" component={PortList} />
            <Route path="port/:refId" title="Port edit" component={PortEdit} />
            <Route path="product" title="Product" component={ProductList} />
            <Route path="product/:refId" title="Product edit" component={ProductTypeEdit} />
            <Route
              path="product/:parentId/sub/:refId" title="Product type edit" component={SubTypeEdit}
            />
            <Route path="expensestype" title="Expenses" component={ExpensesTypeList} />
            <Route path="expensestype/:refId" title="Expenses edit" component={ExpensesTypeEdit} />
            <Route
              path="expensecategory"
              title="Expense Category"
              component={ExpensesCategoryList}
            />
            <Route
              path="expensecategory/:refId"
              title="Expense category edit"
              component={ExpensesCategoryEdit}
            />
            <Route path="currency" title="Currency rates" component={CurrencyLine} />
            <Route path="loadingterm" title="Laytime term" component={LoadingTermList} />
            <Route
              path="loadingterm/:refId" title="Laytime term edit" component={LoadingTermEdit}
            />
            <Route path="owner" title="Owner" component={OwnerList} />
            <Route path="owner/:refId" title="Owner edit" component={OwnerEdit} />
            <Route path="vesselbroker" title="Vessel broker" component={VesselBrokerList} />
            <Route
              path="vesselbroker/:refId" title="Vessel broker edit" component={VesselBrokerEdit}
            />
            <Route
              path="forwarder" title="Loading forwarder"
              component={ForwarderList}
            />
            <Route
              path="forwarder/:refId" title="Loading forwarder edit"
              component={ForwarderEdit}
            />
            <Route
              path="shippingline" title="Loading shipping line"
              component={ShippingLineList}
            />
            <Route
              path="shippingline/:refId" title="Loading shipping line edit"
              component={ShippingLineEdit}
            />
            <Route path="producer" title="Producer" component={ProducerList} />
            <Route path="producer/:refId" title="Producer edit" component={ProducerEdit} />
            <Route path="bank" title="Bank" component={BankList} />
            <Route path="bank/:refId" title="Bank edit" component={BankEdit} />
            <Route path="documenttype" title="Document type" component={DocumentTypeList} />
            <Route
              path="documenttype/:refId"
              title="Document type edit"
              component={DocumentTypeEdit}
            />
            <Route
              path="commoncounterparties"
              title="Common counterparties"
              component={CommonCounterpartiesList}
            />
            <Route
              path="commoncounterparties/:refId"
              title="Common counterparty edit"
              component={CommonCounterpartiesEdit}
            />
            <Route
              path="region"
              title="Region"
              component={RegionList}
            />
            <Route
              path="portgroup"
              title="Port group"
              component={PortGroupList}
            />
            <Route
              path="region/:refId"
              title="Region edit"
              component={RegionEdit}
            />
            <Route
              path="portgroup/:refId"
              title="Port group edit"
              component={PortGroupEdit}
            />
            <Route
              path="paymentmethod/:refId"
              title="Payment method edit"
              component={PaymentMethodEdit}
            />
            <Route
              path="paymentmethod"
              title="Payment method"
              component={PaymentMethodList}
            />
            <Route
              path="tradecounterparty"
              title="Trade counterparties"
              component={TradeCounterpartiesList}
            />
            <Route
              path="tradecounterparty/:refId"
              title="Trade counterparty edit"
              component={TradeCounterpartiesEdit}
            />
            <Route
              path="insurancecompany"
              title="Insurance company"
              component={InsuranceCompanyList}
            />
            <Route
              path="insurancecompany/:refId"
              title="Insurance company edit"
              component={InsuranceCompanyEdit}
            />
            <Route
              path="inspectioncompany"
              title="Inspection company"
              component={InspectionCompanyList}
            />
            <Route
              path="inspectioncompany/:refId"
              title="Inspection company edit"
              component={InspectionCompanyEdit}
            />
            <Route
              path="topmanager"
              title="Top managers"
              component={TopManagerList}
            />
            <Route
              path="topmanager/:refId"
              title="Top manager edit"
              component={TopmanagerEdit}
            />

          </Route>
          <Route path="deals/" component={Deals}>
            <IndexRedirect to="purchase" />
            <Route path="purchase" title="Purchases" component={Purchase} />
            <Route path="transport" title="Transport" component={Transport} />
            <Route path="sale" title="Sales" component={Sale} />
            <Route path="unlinked" title="Unlinked" component={Unlinked} />
            <Route path="inpayments" title="Payments" component={Payments} isPlus />
            <Route path="outpayments" title="Payments" component={Payments} isPlus={false} />
            <Route path="commonpayments" title="Common payments" component={CommonPayments} />
            <Route path="closedpayments" title="Payments" component={Payments} isClosed />
            <Route
              path="counterpartyoutstanding"
              title="Counterparty outstanding"
              component={CounterpartyOutstanding}
              counterpartyOutstanding
            />
            <Route
              path="counterpartyoutstandingvalues"
              title="Counterparty outstanding values"
              component={CounterpartyOutstandingValues}
            />
          </Route>
          <Route
            path="deals/purchase/:dealId"
            title="Purchase edit"
            component={PurchaseEditAndLink}
          />
          <Route
            path="deals/sale/:dealId"
            title="Sale edit"
            component={SaleEditAndLink}
          />
          <Route path="deals/transport/:dealId" title="Transport edit" component={TransportEdit} />
          <Route path="reports/todaysPayments" title="Todays payments" component={TodaysPayments} />
          <Route path="reports/supplyDemand" title="Supply/Demand" component={SupplyDemand} />
          <Route
            path="reports/positionmap"
            title="Position map"
            component={UnlinkedRegions}
          />
          <Route
            path="reports/customreports"
            title="Custom reports"
            component={UnifiedDeals}
          />
          <Route
            path="reports/positionbook"
            title="Position book"
            component={PositionBook}
          />
          <Route
            path="reports/openposition"
            title="Open position"
            component={OpenPosition}
          />
          <Route
            path="reports/profitability"
            title="Profitability reports"
            component={Profitability}
          />
          <Route
            path="reports/volumereport"
            title="Volume reports"
            component={VolumeReport}
          />
          <Route
            path="reports/performance"
            title="Performance reports"
            component={PerformanceReport}
          />
          <Route
            path="reports/analytics"
            title="Analytics reports"
            component={AnalyticsReport}
          />
          <Route
            path="reports/userperformance"
            title="User performance report"
            component={UserPerformanceReport}
          />
          <Route path="reports/map" title="Map" component={MapComponent} />
          <Route path="reports/payments" title="Payments report" component={PaymentsReport} />
          <Route path="reports/multinodal" title="Multinodal report" component={MultiNodalReport} />
          <Route
            path="reports/earningStatements"
            title="Earning statement report"
            component={EarningStatementsReport}
          />
          <Route path="search/global" title="Global search" component={GlobalSearchResults} />
        </Route>
        <Route path="/auth" title="Login" component={Auth} />
        <Route path="/change-password/**" title="Update password" component={PasswordChange} />
        <Route path="/reset-password" title="Reset password" component={PasswordReset} />
      </Router>
    </LoadingScreen>
  </Provider>);
}
